export const convertToBoolean = (value: string | boolean = '') =>
  /true/.test(`${value}`);
